<template lang="pug">
	.campaign-streamings.flex-col.space-medium
		template(v-if="product.Streaming")
			Loader(v-if="!streaming", :text="$tCaption('Loading', '@actions')")
			StreamingCard(v-else="streaming", :record="streaming")
				.flex-row.space(v-if="!info.readonly", slot="actions-right")
					DxButton(:hint="$tCaption('Remove podcast')", type="normal", @click="onStreamingRemove(streaming)", icon="fas fa-times")
		StreamingsSelection.flex-1(v-if="!product.Streaming && !info.readonly", @select="onStreamingSelect", @remove="onStreamingRemove", :info="info", :selected="product.Streaming && [product.Streaming.Oid]", 
			:dapCategories="[product.DapCategory.Oid]", :disableFilters="product.type.disableStreamingsFilters")
			template(slot="left-actions")
				.grey.upper {{$tCaption('Please select streaming')}}
</template>

<script>
	import DxButton from 'devextreme-vue/button';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxDateBox from 'devextreme-vue/date-box';
	import Loader from 'app-core/Loader.vue';
	import Dropdown from 'app-core/Dropdown.vue';
	import StreamingsSelection from './StreamingsSelection.vue';
	import StreamingCard from './StreamingCard.vue';

	export default {
		translationCategory: 'campaign.Detail',
		name: 'campaign-products',
		components: {
			DxButton, DxTextBox, Loader, DxDateBox, Dropdown, StreamingsSelection, StreamingCard
		},
		props: ['info', 'active', 'product'],
		data() {
			return {
				streaming: null
			};
		},
		computed: {
			campaign() {
				return this.info?.campaign;
			},
			campaignProducts() {
				return this.info?.campaignProducts;
			},
		},
		watch: {
			product() {
				this.streaming = null;
				this.loadStreaming();
			}
		},
		mounted() {
			if (__DEBUG__)
				window.campaignStreamings = this;
			this.loadStreaming();
		},
		methods: {
			loadStreaming() {
				if (!this.streaming && this.product.Streaming?.Oid)
					this.$Data.getExternalApi('Streaming/GetStreaming', `streamingId=${this.product.Streaming.Oid}`).then(r => {
						this.streaming = r;
					});
			},
			onStreamingSelect(streaming) {
				if (__DEBUG__)
					console.debug('OnStreamingSelect', streaming);
				this.product.Streaming = streaming;
				this.streaming = streaming;
				this.$emit('change', this.product);
			},
			onStreamingRemove() {
				this.product.Streaming = null;
				this.streaming = null;
				this.$emit('change', this.product);
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";
	.campaign-streamings {

	}
</style>
 